import { STEPPER, STATES, STATES_IDS, STEP_IDS } from './constants'
export const formatDate = (strDate) => {
    const date = new Date(strDate);
    const options = { month: 'long' };
    const day = date.getDate();
    const month = date.toLocaleDateString('es-ES', options);
    return `${day} ${month}`;
}
export const formatDateShort = (strDate) => {
    const date = new Date(strDate);
    const options = { month: 'short' };
    const day = date.getDate();
    const month = date.toLocaleDateString('es-ES', options);
    return `${day} ${month}`;
}
export const searchStepDate = (events, stepID)=>{
    let date = null;
    switch (stepID) {
        case STEP_IDS.STEP_1:{
            const { fecha  } = {...events.find(
                item => (item.estado === STATES_IDS.SOLICITUD ))};
            date=fecha;
            break;
        }
        case STEP_IDS.STEP_2:{
            const { fecha  } = {...events.find(
                item => (item.estado === STATES_IDS.RECOGIDO ))};
            date=fecha;
            break;
        }
        case STEP_IDS.STEP_3:{
            const { fecha  } = {...events.find(
                item => (item.estado === STATES_IDS.RECIBIDO_EN_LABORATORIO))};
            date=fecha;
            break;
        }
        case STEP_IDS.STEP_4:{
            const { fecha  } = {...events.find(
                item => (item.estado === STATES_IDS.EQUIPO_EN_EVALUACION
                    || item.estado === STATES_IDS.EVALUACION_KO_MERCANCIA
                    || item.estado === STATES_IDS.DISPOSITIVO_NO_COINCIDE
                    || item.estado === STATES_IDS.ORDEN_DE_DEVOLUCION_CREADA
                    || item.estado === STATES_IDS.EXPEDICION_DEVOLUCION_CREADA))};
            date=fecha;
            break;
        }
        case STEP_IDS.STEP_5:{
            const { fecha  } = {...events.find(
                item => (item.estado === STATES_IDS.ORDEN_PAGO_GENERADA
                    ||  item.estado === STATES_IDS.DEVOLUCION))};
            date=fecha;
            break;
        }
        default:
            break;
    }
    return date;
}
export const getCurrentStepperInfo = (event) => {
    const currentEvent = Array.isArray(event) && event[event.length-1]
    const { estado: lastState, fecha: lastDate} = currentEvent;
    const lastDateFormat = lastDate ? formatDate(lastDate) : null;
    let searchedActiveStep = false;
    const currentState = STATES[lastState];
    if(currentState.STEP_ID === '0'){
        return [];
    }
    const stepper = STEPPER.map((step)=>{
        if(step.id === currentState.STEP_ID){
            searchedActiveStep = true;
            return {
                ...step,
                isActive: true,
                label: currentState.STEP_LABEL,
                date: lastDateFormat,
                shortDate: lastDate ? formatDateShort(lastDate) : null,
            }
        }else if(!searchedActiveStep){
            const stepDate = searchStepDate(event, step.id);
            if(!stepDate){
                return null;
            }
            return {
                ...step,
                isChecked: true,
                date: stepDate ? formatDate(stepDate) : null,
                shortDate: stepDate ? formatDateShort(stepDate) : null,
            }
        }else{
            return step;
        }
    }).filter((item)=>(item !== null));
    return {
        stepper,
        stepperInfo: {
            title: currentState?.TEXT_INFO_TITLE || '',
            description: currentState?.TEXT_INFO_DESC || '',
            lastDate: lastDateFormat,
        },
        stepperNextSteps: currentState?.NEXT_STEP || [],
        showPickUpData: currentState?.SHOW_PICK_UP_DATA || false,
        refundReason: currentState?.REFUND_REASON || '',
    };
}
  